import { useEffect, useRef, useState } from 'react';
import { RefreshCw } from 'lucide-react';

const CHECK_INTERVAL_MS = 3 * 60 * 1000;

async function fetchBuildId(): Promise<string | null> {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const data = await res.json();
    return data.buildId ?? null;
  } catch {
    return null;
  }
}

// Проверяет раз в несколько минут, не задеплоили ли новую сборку панели (см.
// scripts/write-version.js), и предлагает обновить страницу, если да
export default function UpdateBanner() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const initialBuildId = useRef<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchBuildId().then((id) => {
      if (!cancelled) initialBuildId.current = id;
    });

    const interval = setInterval(async () => {
      const id = await fetchBuildId();
      if (!cancelled && id && initialBuildId.current && id !== initialBuildId.current) {
        setUpdateAvailable(true);
      }
    }, CHECK_INTERVAL_MS);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  if (!updateAvailable) return null;

  return (
    <div className="update-banner">
      <RefreshCw size={15} />
      Вышла новая версия панели
      <button onClick={() => window.location.reload()}>Обновить</button>
    </div>
  );
}
